import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=943e9dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-943e9dea"]])

export default __exports__